<div [formGroup]="form()">
  <iris-form-field [label]="label()" class="large-field">
    <iris-dropdown
      [options]="specialtyOptions()"
      [formControlName]="name()"
      [placeholder]="label()"
      data-test="specialty-dropdown"
    ></iris-dropdown>
  </iris-form-field>
</div>
